/* SFT — The Bestsellers Edit. Vanilla JS: scroll reveals + mood switcher tabs.
   Guarded so repeated <script> tags across sections init once. */
(function () {
  'use strict';

  if (window.__sftBestsellersLoaded) return;
  window.__sftBestsellersLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Scroll reveals (fade-up / blur-to-sharp) ---------- */
  function initReveals(root) {
    var items = (root || document).querySelectorAll('[data-be-reveal]:not(.be-in)');
    if (!items.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('be-in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('be-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    items.forEach(function (el, i) {
      if (!el.style.getPropertyValue('--be-delay') && el.hasAttribute('data-be-stagger')) {
        el.style.setProperty('--be-delay', Math.min(i * 0.09, 0.45) + 's');
      }
      observer.observe(el);
    });
  }

  /* ---------- Mood switcher (accessible tabs) ---------- */
  function initTabs(section) {
    if (section.__beInit) return;
    section.__beInit = true;

    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-be-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-be-panel]'));
    var medias = Array.prototype.slice.call(section.querySelectorAll('[data-be-media]'));
    if (!tabs.length) return;

    function select(index, focusTab) {
      tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (active) {
          var bg = tab.getAttribute('data-be-bg');
          if (bg) section.style.setProperty('--be-bg', bg);
          if (focusTab) tab.focus();
        }
      });
      panels.forEach(function (panel, i) {
        if (i === index) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
      medias.forEach(function (media, i) {
        media.classList.toggle('be-active', i === index);
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        select(i, false);
      });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        select(next, true);
      });
    });

    select(0, false);
  }

  function initAll(root) {
    initReveals(root);
    (root || document).querySelectorAll('[data-be-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* Re-init when the theme editor re-renders a section */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
